import axios from "axios";

const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/OfficeApplianceBrand";

export const deactivateOfficeApplianceBrands = async (brandIds: number[]) => {
  await axios.put(`${api_base_url}/Deactivate`, brandIds);
};
